import LocationsForm from './component';

export default LocationsForm;
